<p-dialog
  header="この課題を引用する"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [(visible)]="isShow"
  styleClass="dialog"
>

  <div class="p-col-12 text-group p-d-flex p-jc-center p-text-bold">
    <div class="p-col-10">
      <span class="p-m-0">
        <p class="tier">
          現在閲覧している課題の以下の項目が、入力フォームに自動コピーされますので、<br>
          必要な箇所を修正の上、自団体の課題として登録してください。<br>
        </p>
        <h4 class="p-m-0 text-large">
        【コピーされる項目】
        </h4>
        <div class="tier">
          ・タイトル<br>
          ・カテゴリ<br>
          ・解決したい課題内容<br>
          ・課題に対する現在の取組<br>
          ・提案者側に期待すること<br>
          ・定量的な目標値<br>
          ・目指すSDGsゴール
        </div>
      </span>
    </div>
  </div>

  <p-footer>
    <div class="button-group p-d-flex p-jc-center">
      <button
        pButton
        type="button"
        label="OK"
        class="button-accept mr-4"
        (click)="confirm()"
        ></button>
      <button
        pButton
        type="button"
        label="キャンセル"
        class="button-cancel"
        (click)="closeDialog()"
      ></button>
    </div>
  </p-footer>
</p-dialog>
